import { render, staticRenderFns } from "./header-footer.vue?vue&type=template&id=4ad02b1c&"
import script from "./header-footer.vue?vue&type=script&lang=js&"
export * from "./header-footer.vue?vue&type=script&lang=js&"
import style0 from "./header-footer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports